import { render, staticRenderFns } from "./configSettingsChartsWrapper.vue?vue&type=template&id=549b9776&scoped=true"
import script from "./configSettingsChartsWrapper.vue?vue&type=script&lang=js"
export * from "./configSettingsChartsWrapper.vue?vue&type=script&lang=js"
import style0 from "./configSettingsChartsWrapper.vue?vue&type=style&index=0&id=549b9776&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "549b9776",
  null
  
)

export default component.exports